import * as React from 'react';

import { ToggleGroup, ToggleGroupItem } from './components/ui/toggle-group.js';

export function DimeToggleGroup({ ...props }: Readonly<React.ComponentProps<typeof ToggleGroup>>) {
  return <ToggleGroup {...props} />;
}

DimeToggleGroup.displayName = 'DimeToggleGroup';

export function DimeToggleGroupItem({
  ...props
}: Readonly<React.ComponentProps<typeof ToggleGroupItem>>) {
  return <ToggleGroupItem {...props} />;
}

DimeToggleGroupItem.displayName = 'DimeToggleGroupItem';
